import { render, staticRenderFns } from "./OAuth2Callback.vue?vue&type=template&id=2a62ed2e&"
import script from "./OAuth2Callback.vue?vue&type=script&lang=js&"
export * from "./OAuth2Callback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports